import { pathOr } from 'ramda';
import Size from '../../../../models/constants/size';

export const avatarSizes = {
  [Size.SMALL]: 30,
  [Size.MEDIUM]: 50,
  [Size.LARGE]: 100,
  [Size.XLARGE]: 140,
};

const size = (size: Size) => {
  const a = pathOr(avatarSizes[Size.MEDIUM], [size], avatarSizes);
  return {
    width: a,
    height: a,
  };
};

const rotate = (r) => {
  if (r) {
    return {
      transform: `rotate(${r})`,
    };
  }
  return {};
};

export default {
  rotate,
};
